'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactResponsiveDropdown = require('react-responsive-dropdown');

var _reactResponsiveDropdown2 = _interopRequireDefault(_reactResponsiveDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popover = function Popover(_ref) {
  var children = _ref.children,
      clickOverlay = _ref.clickOverlay,
      dropdownView = _ref.dropdownView,
      overlayOptions = _ref.overlayOptions,
      visible = _ref.visible,
      width = _ref.width;

  return _react2.default.createElement(
    _reactResponsiveDropdown2.default,
    _extends({
      arrowSize: 10,
      borderColor: '#ccc',
      borderRadius: 0,
      borderWidth: 2,
      clickOverlay: clickOverlay,
      dropdownView: _react2.default.createElement(
        'div',
        { className: 'Popover' },
        dropdownView
      ),
      visible: visible,
      width: width
    }, overlayOptions),
    children
  );
};

Popover.propTypes = {
  /** Child DOM elements comprising the content of the popover. */
  children: _propTypes2.default.any,
  /** Function to be called when clicking outside the popover. */
  clickOverlay: _propTypes2.default.func,
  /** The content of the popover. */
  dropdownView: _propTypes2.default.element,
  /** Overlay options. */
  overlayOptions: _propTypes2.default.object,
  /** Whether the popover is visible. */
  visible: _propTypes2.default.bool,
  /** Width of the popover. */
  width: _propTypes2.default.number
};

Popover.defaultProps = {
  children: null,
  clickOverlay: null,
  dropdownView: null,
  overlayOptions: {},
  visible: false,
  width: 300
};

exports.default = Popover;
Popover.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Popover',
  'props': {
    'children': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'any'
      },
      'required': false,
      'description': 'Child DOM elements comprising the content of the popover.'
    },
    'clickOverlay': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function to be called when clicking outside the popover.'
    },
    'dropdownView': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'element'
      },
      'required': false,
      'description': 'The content of the popover.'
    },
    'overlayOptions': {
      'defaultValue': {
        'value': '{}',
        'computed': false
      },
      'type': {
        'name': 'object'
      },
      'required': false,
      'description': 'Overlay options.'
    },
    'visible': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the popover is visible.'
    },
    'width': {
      'defaultValue': {
        'value': '300',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'Width of the popover.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Popover.js
// module id = 190
// module chunks = 0